import type { GaApp } from '~/modules/app'
import { mapUserPositionsResponse } from '~/modules/main'

export class MenuService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }

  async loadProfile(): Promise<void> {
    const menu = this.gaApp.stores.main.menu

    menu.isProfileLoading = true
    menu.hasProfileError = false

    try {
      const response =
        await this.gaApp.services.main.api.getLeaderboardMyPositions()

      menu.profile = mapUserPositionsResponse(response)
    } catch (error) {
      menu.hasProfileError = true
      menu.profile = null
    } finally {
      menu.isProfileLoading = false
    }
  }
}
